<div class="container">
  <div class="text-center">
    <strong class="mainHeading">Percentage Configuration</strong>
  </div>

  <div class="d-flex justify-content-between mt-2">
    <div class="d-flex gap-3">
      <button
        class="btn btn-outline-primary me-2"
        ngbTooltip="Export"
        (click)="exportToExcel()"
      >
        <i class="bi bi-box-arrow-right me-2"></i>
        Export
      </button>
      <button
        class="btn btn-success me-2"
        (click)="exportToPDF()"
        ngbTooltip="Print"
      >
        <span><i class="bi bi-printer me-2"></i></span>Print
      </button>
      <button
        class="btn btn-outline-danger"
        ngbTooltip="Clear Filter"
        (click)="clearFilter()"
      >
        <i class="bi bi-x-circle me-2"></i> Clear Filter
      </button>
    </div>
    <div class="d-flex align-items-center gap-2" style="width: 23%">
      <label for="typeOfUser" class="mb-0 flex-shrink-0">Select City</label>
      <select
        (change)="onFilterCityChange($event)"
        class="form-select flex-grow-1"
      >
        <option value="all">All</option>
        <option *ngFor="let city of cityList" [value]="city.id">
          {{ city.cityName }}
        </option>
      </select>
    </div>
  </div>

  <div class="card shadow-lg p-4 mt-3">
    <div class="table-responsive">
      <table class="table table-bordered table-striped">
        <thead class="table-warning text-center">
          <tr>
            <!-- <th>Container ID</th> -->
            <th>City</th>
            <th>Container Rental Percentage</th>
            <th>Trip Charges Percentage</th>
            <th>Disposal Charges Percentage</th>
            <!-- <th>Action</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let commission of pagedData">
            <td class="text-center">{{ commission.cityName }}</td>
            <td class="text-center">
              {{ commission.containerRentalPercentage }}
            </td>
            <td class="text-center">{{ commission.tripsPercentage }}</td>
            <td class="text-center">{{ commission.disposalPercentage }}</td>
            <!-- <td class="text-center">
                            <i class="bi bi-plus-square text-danger" (click)="editItem(commission, createModal)" style="cursor: pointer"></i>
                        </td> -->
          </tr>
          <tr *ngIf="allCommissionList?.length === 0">
            <td colspan="10" class="text-center">No Data Found</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-3">
      <div class="d-flex justify-content-center flex-grow-1">
        <ngb-pagination
          *ngIf="allCommissionList?.length > 0"
          [(page)]="page"
          [pageSize]="pageSize"
          [collectionSize]="allCommissionList?.length"
          (pageChange)="onPageChange($event)"
          [boundaryLinks]="true"
        >
        </ngb-pagination>
      </div>

      <div *ngIf="allCommissionList?.length > 0" class="text-muted mb-3">
        <strong
          >Showing {{ (page - 1) * pageSize + 1 }} to
          {{
            page * pageSize > allCommissionList?.length
              ? allCommissionList?.length
              : page * pageSize
          }}
          of {{ allCommissionList?.length }} entries</strong
        >
      </div>
    </div>
  </div>

  <!-- Modal for Create/Edit -->

  <ng-template #createModal let-modal>
    <div class="modal-header custom-modal-header">
      <h2 class="modal-title mt-3">
        {{
          isEditMode
            ? "Edit Percentage Configuration"
            : "Percentage Configuration"
        }}
      </h2>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss()"
      ></button>
    </div>

    <form [formGroup]="percentageForm">
      <div class="modal-body">
        <div class="mb-3" style="width: 50%">
          <label for="typeOfUser" class="form-label mb-0 flex-shrink-0"
            >Select City</label
          >
          <select
            formControlName="cityId"
            (change)="onCityChange($event)"
            class="form-select flex-grow-1"
            [ngClass]="{
              'invalid-field':
                percentageForm.controls['cityId'].invalid &&
                percentageForm.controls['cityId'].touched
            }"
          >
            <option value="all">All</option>
            <option *ngFor="let city of cityList" [value]="city.id">
              {{ city.cityName }}
            </option>
          </select>
        </div>
        <!-- Container Rental Percentage -->
        <div class="mb-3">
          <label class="form-label">Container Rental Percentage</label>
          <div class="input-group">
            <input
              type="number"
              class="form-control"
              formControlName="containerRentalPercentage"
              min="0"
              max="100"
              [ngClass]="{
                'invalid-field':
                  percentageForm.controls['containerRentalPercentage']
                    .invalid &&
                  percentageForm.controls['containerRentalPercentage'].touched
              }"
            />
            <span class="input-group-text">%</span>
          </div>
        </div>

        <!-- Trips Percentage -->
        <div class="mb-3">
          <label class="form-label">Trips Percentage</label>
          <div class="input-group">
            <input
              type="number"
              class="form-control"
              formControlName="tripsPercentage"
              min="0"
              max="100"
              [ngClass]="{
                'invalid-field':
                  percentageForm.controls['tripsPercentage'].invalid &&
                  percentageForm.controls['tripsPercentage'].touched
              }"
            />
            <span class="input-group-text">%</span>
          </div>
        </div>

        <!-- Disposal Percentage -->
        <div class="mb-3">
          <label class="form-label">Disposal Percentage</label>
          <div class="input-group">
            <input
              type="number"
              class="form-control"
              formControlName="disposalPercentage"
              min="0"
              max="100"
              [ngClass]="{
                'invalid-field':
                  percentageForm.controls['disposalPercentage'].invalid &&
                  percentageForm.controls['disposalPercentage'].touched
              }"
            />
            <span class="input-group-text">%</span>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-success"
          (click)="addPercentageDetails(modal, isEditMode ? 'edit' : 'new')"
        >
          {{ isEditMode ? "Update" : "Submit" }}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          (click)="modal.dismiss()"
        >
          Cancel
        </button>
      </div>
    </form>
  </ng-template>
</div>
